<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 auth-logo-container signup-bg-color">
      <b-link class="app-logo">
        <app-logo-svg />
      </b-link>
      <b-col
        id="auth-left-container"
        lg="7"
        class="d-none d-lg-flex align-items-center"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <!-- Left Video-->
          <app-video />
        </div>
      </b-col>
      <!-- Login-->
      <b-col
        lg="5"
        class="d-flex justify-content-center auth-bg auth-reg signup-portion signup-bg-color"
      >
        <div
          class="
            d-flex
            flex-column
            font-montserrat
          "
        >
          <div class="w-100 signup-welcome-section">
            <div class="text-center">
              <p class="header-text">
                Adventure starts here 🚀
              </p>
              <p class="sub-header">
                You have been invited to see what is available on the platform
              </p>
            </div>
          </div>
          <div class="body-child-routes">
            <validation-observer
              #default="{ invalid }"
            >
              <b-form @submit.prevent="onSubmit">
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  vid="email"
                  rules="required|email"
                >
                  <div class="child-header mrg-bottom-16">
                    Enter your e-mail to get access
                  </div>
                  <b-form-group
                    class="custom-input-group mrg-bottom-16"
                    :class="
                      isDirtyGuestEmail ? errors.length > 0 ? 'invalid-input-group' : 'valid-input-group' : '' "
                  >
                    <b-form-input
                      v-model="guestEmail"
                      class="custom-input"
                      type="email"
                      placeholder="Email"
                    />
                    <span
                      class="custom-input-placeholder text-capitalize font-montserrat"
                      data-content="Email"
                    >
                      Email
                    </span>
                    <validation-icon-with-tooltip
                      id="email-validation"
                      class="kp-validation-icon"
                      :show="!!(errors.length > 0)"
                      :errors="errors"
                    />
                  </b-form-group>
                </validation-provider>
                <b-button
                  type="submit"
                  class="font-inter custom-btn-submit mrg-bottom-16"
                  variant="info"
                  block
                  :disabled="invalid || loading"
                >
                  <b-spinner
                    v-if="loading"
                    class="register-spinner"
                  />
                  <span v-else> GET ACCESS </span>
                </b-button>
              </b-form>
            </validation-observer>
          </div>
        </div>
        <div class="font-montserrat have-an-account">
          Want to create an account
          <b-link
            to="/register"
            class="cursor-pointer hyperlink-text-style"
          >
            Sign Up
          </b-link>
          now!
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import {
 BRow, BLink, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner,
} from 'bootstrap-vue'
import AppLogoSvg from '@/@core/assets/svg-components/AppLogoSvg.vue'
import AppVideo from '@/assets/videos/AppVideo.vue'
import ValidationIconWithTooltip from '@/@core/components/icon-with-tooltip-error/ValidationIconWithTooltip.vue'
import store from '@/store'
import { GUEST_USER_LOGIN, PURGE_AUTH } from '@/store/modules/auth.module'
import { apiToastError, apiToastSuccess } from '@/@core/utils/toast'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { constants } from '@kingpin-global/kingpin-utils-frontend'

const { ROLES } = constants

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BSpinner,
        AppLogoSvg,
        AppVideo,
        ValidationIconWithTooltip,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            isInvalidEmail: false,
            guestEmail: '',
            isDirtyGuestEmail: false,
            loading: false,
            // validation
            required,
            email,
        }
    },
    watch: {
      guestEmail(val) {
        if (val) {
          this.isDirtyGuestEmail = true
        }
      },
  },
    mounted() {
      store.dispatch(PURGE_AUTH)
    },
    methods: {
        onSubmit() {
            this.loading = true
            const payload = {
                guestEmail: this.guestEmail,
            }
            store.dispatch(GUEST_USER_LOGIN, payload)
                .then(res => {
                    this.loading = false
                    apiToastSuccess(res.message)
                     this.$router.push(getHomeRouteForLoggedInUser(ROLES.GUEST))
                })
                .catch(err => {
                    this.loading = false
                    apiToastError(err)
                })
        },
    },

}
</script>
<style lang="scss">
@import '~@core/scss/vue/pages/page-auth.scss';
@import '~@core/scss/vue/pages/signup/signup-page.scss';
@import '~@core/scss/vue/pages/signup/kp-signup.scss';
@import '~@core/scss/base/bootstrap-extended/include'; // Bootstrap includes
.register-spinner{
    border: 0.25em solid $info;
    border-right-color: transparent;
}
.custom-btn-submit{
  font-weight: 700;
  &.disabled{
    background-color: rgba($info,20%) !important;
    border: 1px solid transparent !important;
  }
}
</style>
